export let FlexBoxAlignItems = /*#__PURE__*/function (FlexBoxAlignItems) {
  FlexBoxAlignItems["Start"] = "Start";
  FlexBoxAlignItems["Center"] = "Center";
  FlexBoxAlignItems["End"] = "End";
  FlexBoxAlignItems["Baseline"] = "Baseline";
  FlexBoxAlignItems["Stretch"] = "Stretch";
  return FlexBoxAlignItems;
}({});